module.exports = __webpack_public_path__ + "static/media/farmIcon.32bfb93c.svg";